<template>
  <Dialog id="failModal" :position="props.position" @hide="emitDismiss" :visible="visible" :modal="true" :closable="false"
    :draggable="false">
    <template #header>
      <span style="color: red">{{ props.header }}</span>
    </template>
    {{ props.message }}

    <template #footer>
      <Button label="OK" icon="pi pi-check" autofocus @click="emitDismiss" />
    </template>
  </Dialog>
</template>
<script lang="ts" setup>
import type { positions } from "~/types/modals";

const props = withDefaults(defineProps<{
  header: string;
  message: string;
  position?: positions;
  visible?: boolean
}>(), {
  position: "center",
  visible: true
});

const emit = defineEmits(["fail-login-modal-dismiss"])



function emitDismiss() {
  emit("fail-login-modal-dismiss")
}


</script>